export interface Game {
  id: string;
  name: string;
  universe: string;
  language: string;
  status: 'setup' | 'active' | 'paused' | 'completed';
  current_turn_player_id?: string;
  share_code?: string;
  max_players: number;
  current_turn_number: number;
  world_description?: string;
  world_metadata?: any;
  created_at: string;
  updated_at: string;
  players_count?: number;
  players?: Player[];
}

export interface Player {
  id: string;
  game_id: string;
  name: string;
  role?: string;
  avatar_data?: {
    photos: string[];
    embeddings?: any;
    model: string;
  };
  stats?: any;
  resources?: any;
  inventory?: any[];
  abilities?: string[];
  position?: string;
  current_location_id?: string;
  experience_points: number;
  is_alive: boolean;
  player_order?: number;
  created_at: string;
}

export const POPULAR_UNIVERSES = [
  { value: 'star-wars', label: 'Star Wars', nameRu: 'Звёздные войны' },
  { value: 'lord-of-the-rings', label: 'Lord of the Rings', nameRu: 'Властелин колец' },
  { value: 'narnia', label: 'Chronicles of Narnia', nameRu: 'Хроники Нарнии' },
  { value: 'witcher', label: 'The Witcher', nameRu: 'Ведьмак' },
  { value: 'game-of-thrones', label: 'Game of Thrones', nameRu: 'Игра престолов' },
  { value: 'dnd-forgotten-realms', label: 'D&D: Forgotten Realms', nameRu: 'D&D: Забытые королевства' },
  { value: 'cyberpunk', label: 'Cyberpunk', nameRu: 'Киберпанк' },
  { value: 'warhammer-40k', label: 'Warhammer 40,000', nameRu: 'Warhammer 40,000' },
  { value: 'harry-potter', label: 'Harry Potter', nameRu: 'Гарри Поттер' },
  { value: 'marvel', label: 'Marvel Universe', nameRu: 'Вселенная Marvel' },
  { value: 'mass-effect', label: 'Mass Effect', nameRu: 'Mass Effect' },
  { value: 'elder-scrolls', label: 'The Elder Scrolls', nameRu: 'The Elder Scrolls' },
  { value: 'fallout', label: 'Fallout', nameRu: 'Fallout' },
  { value: 'matrix', label: 'The Matrix', nameRu: 'Матрица' },
  { value: 'dune', label: 'Dune', nameRu: 'Дюна' },
  { value: 'blade-runner', label: 'Blade Runner', nameRu: 'Бегущий по лезвию' },
  { value: 'star-trek', label: 'Star Trek', nameRu: 'Звёздный путь' },
  { value: 'discworld', label: 'Discworld', nameRu: 'Плоский мир' },
  { value: 'custom', label: 'Custom Universe', nameRu: 'Своя вселенная' },
];

export const LANGUAGES = [
  { value: 'ru', label: 'Русский', flag: '🇷🇺' },
  { value: 'en', label: 'English', flag: '🇺🇸' },
  { value: 'es', label: 'Español', flag: '🇪🇸' },
  { value: 'fr', label: 'Français', flag: '🇫🇷' },
  { value: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { value: 'it', label: 'Italiano', flag: '🇮🇹' },
  { value: 'pt', label: 'Português', flag: '🇵🇹' },
  { value: 'ja', label: '日本語', flag: '🇯🇵' },
  { value: 'zh', label: '中文', flag: '🇨🇳' },
  { value: 'ko', label: '한국어', flag: '🇰🇷' },
  { value: 'pl', label: 'Polski', flag: '🇵🇱' },
  { value: 'uk', label: 'Українська', flag: '🇺🇦' },
];
